import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Feature from './feature';

class FeaturesColumn extends React.Component {
	constructor(props) {
		super(props);

		this.renderFeatures = this.renderFeatures.bind(this);
	}

	renderFeatures(current_feature, index) {
  	return (
  		<div
  			key={index}
  			className={this.props.featuresColumnClassName}>
  			<Feature
  				feature_node={current_feature}
  				isNested={false}
  				featuresHeadingOpenClassName={this.props.featuresHeadingOpenClassName}
					featuresHeadingClosedClassName={this.props.featuresHeadingClosedClassName}
					parentFeatureWrapperClassName={this.props.parentFeatureWrapperClassName}
					parentFeatureBodyClassName={this.props.parentFeatureBodyClassName}
					nestedFeatureWrapperClassName={this.props.nestedFeatureWrapperClassName}
					nestedFeatureBodyClassName={this.props.nestedFeatureBodyClassName}
					handleChange={this.props.handleChange}
					popoverPosition={this.props.popoverPosition}
					current_entity={this.props.current_entity}
  				/>
  		</div>
  	);
  }

	render() {
    let parent_features_array = this.props.features.features_tree.filter(f => {
    	return f.feature.path.split('/').filter(e => e !== '').length === 1
    });

  	let filtered_features_array = parent_features_array.filter((f, i) => {
  		return i % this.props.numOfColumns === this.props.index;
  	})

  	return (
  		<div>
  			{filtered_features_array.map(this.renderFeatures)}
  		</div>
		)
  }
}

let mapStateToProps = ({features}) => ({features})

export default connect(mapStateToProps)(FeaturesColumn)



// WEBPACK FOOTER //
// ./src/browser/components/features/featuresColumn.js